export const memoryRemindersKeys = {
    all: () => ['memoryReminders']
};
//# sourceMappingURL=memoryReminders.keys.js.map